import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedOtherWorkTypeList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
}

interface IUseOtherWorkTypes {
  ordering?: string;
  limit?: string;
}

function useOtherWorkTypes({
  ordering,
  limit = '20',
}: IUseOtherWorkTypes): UseInfiniteQueryResult<AxiosResponse<PaginatedOtherWorkTypeList>> {
  const fetchOtherWorkTypes = useCallback(
    ({
      pageParam = { limit, offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedOtherWorkTypeList>> => {
      return client.get(`other-work-types/?${encodeUrlParams(pageParam)}`);
    },
    [limit],
  );

  return useInfiniteQuery(['otherWorkTypes', ordering], fetchOtherWorkTypes, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useOtherWorkTypes;
